import {
  descriptionUI,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import FinancialsNeededDescription from '../../../../components/FormDescriptions/FinancialsNeededDescription';
import { emptyObjectSchema } from '../../../../definitions';
import content from '../../../../locales/en/content.json';

export default {
  uiSchema: {
    ...titleUI(content['household-info--financials-needed-title']),
    ...descriptionUI(FinancialsNeededDescription),
  },
  schema: emptyObjectSchema,
};
